import React from "react";

import { useFormikContext } from "formik";
import {
  ImageSizeEnum,
  ImageStyleEnum,
  ImageToneEnum,
} from "../../../../enums/template";
import { Template } from "../../../../models";

import SwitchContainer from "../common/SwitchContainer";

export default function IncludeImageToggle() {
  const { values, setFieldValue } = useFormikContext<Partial<Template>>();

  const handleToggleIncludeImage = () => {
    const updatedIncludeImage = !values?.includeImage;
    setFieldValue("includeImage", updatedIncludeImage);
    if (updatedIncludeImage && !values.imageSizeId) {
      setFieldValue("imageSizeId", ImageSizeEnum.LANDSCAPE);
    }

    if (updatedIncludeImage && !values.imageStyleId) {
      setFieldValue("imageStyleId", ImageStyleEnum.REALISTIC);
    }

    if (updatedIncludeImage && !values.imageToneId) {
      setFieldValue("imageToneId", ImageToneEnum.VIBRANT);
    }

    setFieldValue("excludeImageText", updatedIncludeImage ? true : null);
    setFieldValue("excludeImageFaces", updatedIncludeImage ? true : null);
  };

  return (
    <SwitchContainer
      title="Include Image"
      subTitle="Add an image to the article."
      tooltip="A unique, non-stock image will be generated based on the content of the article."
      enabled={Boolean(values?.includeImage)}
      setEnabled={handleToggleIncludeImage}
    />
  );
}
